<main class="background">
  <mzic-header></mzic-header>
  <router-outlet></router-outlet>
</main>
